import { EHouseMaterial } from '../../../../../../../packages/api-models/common/json_query';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectConstructionTypeFilter } from 'shared/selectors/advancedFilters';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { NonEmptyArray } from '../../../../../../../packages/JsonQuery';

export const ConstructionTypeContainer: FC = () => {
  const { label, value, options } = useSelector(selectConstructionTypeFilter);

  const onChange = useFilterChangeCallback();

  const handleConstructionTypeChange = useCallback(
    (newValue: NonEmptyArray<EHouseMaterial> | null) => {
      onChange({ action: 'setConstructionTypes', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleConstructionTypeChange} />
    </AdvancedFilterRow>
  );
};
